import { render, staticRenderFns } from "./ButtonFour.vue?vue&type=template&id=658e9152&"
import script from "./ButtonFour.vue?vue&type=script&lang=ts&"
export * from "./ButtonFour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports